/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoMeanAirTemperature } from './AnalysisResultDtoMeanAirTemperature';
import {
    AnalysisResultDtoMeanAirTemperatureFromJSON,
    AnalysisResultDtoMeanAirTemperatureFromJSONTyped,
    AnalysisResultDtoMeanAirTemperatureToJSON,
} from './AnalysisResultDtoMeanAirTemperature';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';
import type { AnalysisResultDtoAreaFlatness } from './AnalysisResultDtoAreaFlatness';
import {
    AnalysisResultDtoAreaFlatnessFromJSON,
    AnalysisResultDtoAreaFlatnessFromJSONTyped,
    AnalysisResultDtoAreaFlatnessToJSON,
} from './AnalysisResultDtoAreaFlatness';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';
import type { AnalysisResultDtoBeamDoseOutput } from './AnalysisResultDtoBeamDoseOutput';
import {
    AnalysisResultDtoBeamDoseOutputFromJSON,
    AnalysisResultDtoBeamDoseOutputFromJSONTyped,
    AnalysisResultDtoBeamDoseOutputToJSON,
} from './AnalysisResultDtoBeamDoseOutput';
import type { AnalysisResultDtoBeamQualityFactor } from './AnalysisResultDtoBeamQualityFactor';
import {
    AnalysisResultDtoBeamQualityFactorFromJSON,
    AnalysisResultDtoBeamQualityFactorFromJSONTyped,
    AnalysisResultDtoBeamQualityFactorToJSON,
} from './AnalysisResultDtoBeamQualityFactor';
import type { AnalysisResultDtoAirPressure } from './AnalysisResultDtoAirPressure';
import {
    AnalysisResultDtoAirPressureFromJSON,
    AnalysisResultDtoAirPressureFromJSONTyped,
    AnalysisResultDtoAirPressureToJSON,
} from './AnalysisResultDtoAirPressure';
import type { AnalysisResultDtoXProfile } from './AnalysisResultDtoXProfile';
import {
    AnalysisResultDtoXProfileFromJSON,
    AnalysisResultDtoXProfileFromJSONTyped,
    AnalysisResultDtoXProfileToJSON,
} from './AnalysisResultDtoXProfile';

/**
 * 
 * @export
 * @interface AnalysisResultDto
 */
export interface AnalysisResultDto {
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysisResultDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    creatorUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    lastModifierUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    measurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    zeroMeasurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof AnalysisResultDto
     */
    evaluationScopeCategory?: EvaluationScopeCategory;
    /**
     * 
     * @type {AnalysisResultDtoAirPressure}
     * @memberof AnalysisResultDto
     */
    airPressure?: AnalysisResultDtoAirPressure | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    airPressureFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoMeanAirTemperature}
     * @memberof AnalysisResultDto
     */
    meanAirTemperature?: AnalysisResultDtoMeanAirTemperature | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    meanAirTemperatureFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof AnalysisResultDto
     */
    areaFlatness?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    areaFlatnessFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoBeamDoseOutput}
     * @memberof AnalysisResultDto
     */
    beamDoseOutput?: AnalysisResultDtoBeamDoseOutput | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamDoseOutputFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof AnalysisResultDto
     */
    beamProfileConstancy?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamProfileConstancyFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoBeamQualityFactor}
     * @memberof AnalysisResultDto
     */
    beamQualityFactor?: AnalysisResultDtoBeamQualityFactor | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamQualityFactorFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoXProfile}
     * @memberof AnalysisResultDto
     */
    xProfile?: AnalysisResultDtoXProfile | null;
    /**
     * 
     * @type {AnalysisResultDtoXProfile}
     * @memberof AnalysisResultDto
     */
    yProfile?: AnalysisResultDtoXProfile | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    $type?: AnalysisResultDtoTypeEnum;
}


/**
 * @export
 */
export const AnalysisResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAnalysisComponentDtoAnalysisResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.AnalysisComponent.Dto.AnalysisResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AnalysisResultDtoTypeEnum = typeof AnalysisResultDtoTypeEnum[keyof typeof AnalysisResultDtoTypeEnum];



/**
 * Check if a given object implements the AnalysisResultDto interface.
 */
export function instanceOfAnalysisResultDto(value?: unknown): value is AnalysisResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AnalysisResultDtoTypeEnum)[0];
}

export function AnalysisResultDtoFromJSON(json: any): AnalysisResultDto {
    return AnalysisResultDtoFromJSONTyped(json, false);
}

export function AnalysisResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'creatorUser': json['creatorUser'] == null ? undefined : json['creatorUser'],
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : json['lastModifierUser'],
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
        'zeroMeasurementId': json['zeroMeasurementId'] == null ? undefined : json['zeroMeasurementId'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'] == null ? undefined : json['calibrationCertificateNumber'],
        'evaluationScopeCategory': json['evaluationScopeCategory'] == null ? undefined : EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        'airPressure': json['airPressure'] == null ? undefined : AnalysisResultDtoAirPressureFromJSON(json['airPressure']),
        'airPressureFault': json['airPressureFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['airPressureFault']),
        'meanAirTemperature': json['meanAirTemperature'] == null ? undefined : AnalysisResultDtoMeanAirTemperatureFromJSON(json['meanAirTemperature']),
        'meanAirTemperatureFault': json['meanAirTemperatureFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['meanAirTemperatureFault']),
        'areaFlatness': json['areaFlatness'] == null ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['areaFlatness']),
        'areaFlatnessFault': json['areaFlatnessFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['areaFlatnessFault']),
        'beamDoseOutput': json['beamDoseOutput'] == null ? undefined : AnalysisResultDtoBeamDoseOutputFromJSON(json['beamDoseOutput']),
        'beamDoseOutputFault': json['beamDoseOutputFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamDoseOutputFault']),
        'beamProfileConstancy': json['beamProfileConstancy'] == null ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['beamProfileConstancy']),
        'beamProfileConstancyFault': json['beamProfileConstancyFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamProfileConstancyFault']),
        'beamQualityFactor': json['beamQualityFactor'] == null ? undefined : AnalysisResultDtoBeamQualityFactorFromJSON(json['beamQualityFactor']),
        'beamQualityFactorFault': json['beamQualityFactorFault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamQualityFactorFault']),
        'xProfile': json['xProfile'] == null ? undefined : AnalysisResultDtoXProfileFromJSON(json['xProfile']),
        'yProfile': json['yProfile'] == null ? undefined : AnalysisResultDtoXProfileFromJSON(json['yProfile']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AnalysisResultDtoToJSON(value?: Omit<AnalysisResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'creatorUser': value['creatorUser'],
        'lastModifierUser': value['lastModifierUser'],
        'measurementId': value['measurementId'],
        'zeroMeasurementId': value['zeroMeasurementId'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value['evaluationScopeCategory']),
        'airPressure': AnalysisResultDtoAirPressureToJSON(value['airPressure']),
        'airPressureFault': AnalysisResultDtoAirPressureFaultToJSON(value['airPressureFault']),
        'meanAirTemperature': AnalysisResultDtoMeanAirTemperatureToJSON(value['meanAirTemperature']),
        'meanAirTemperatureFault': AnalysisResultDtoAirPressureFaultToJSON(value['meanAirTemperatureFault']),
        'areaFlatness': AnalysisResultDtoAreaFlatnessToJSON(value['areaFlatness']),
        'areaFlatnessFault': AnalysisResultDtoAirPressureFaultToJSON(value['areaFlatnessFault']),
        'beamDoseOutput': AnalysisResultDtoBeamDoseOutputToJSON(value['beamDoseOutput']),
        'beamDoseOutputFault': AnalysisResultDtoAirPressureFaultToJSON(value['beamDoseOutputFault']),
        'beamProfileConstancy': AnalysisResultDtoAreaFlatnessToJSON(value['beamProfileConstancy']),
        'beamProfileConstancyFault': AnalysisResultDtoAirPressureFaultToJSON(value['beamProfileConstancyFault']),
        'beamQualityFactor': AnalysisResultDtoBeamQualityFactorToJSON(value['beamQualityFactor']),
        'beamQualityFactorFault': AnalysisResultDtoAirPressureFaultToJSON(value['beamQualityFactorFault']),
        'xProfile': AnalysisResultDtoXProfileToJSON(value['xProfile']),
        'yProfile': AnalysisResultDtoXProfileToJSON(value['yProfile']),
        '$type': value['$type'],
    });
}

